import(/* webpackMode: "eager" */ "D:\\Github-Agents\\GHA-5\\_work\\FBO\\FBO\\Procom.Phoenix.Web\\Phoenix\\microapps\\commission-dashboard\\app\\page.tsx");
